"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useToken;

var _react = _interopRequireWildcard(require("react"));

var _getAuthToken = require("../util/getAuthToken");

var _getProperty = require("../util/getProperty");

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MIN_TTL = 20;
var TOKEN_SETUP = false;
var TOKEN_CACHE = null;
var TOKEN_LOADING = false;
var LAST_TOKEN_REQUEST = 0; // a log function that outputs to the console messages and timestamps

var log = function log() {
  var _console;

  for (var _len = arguments.length, msg = new Array(_len), _key = 0; _key < _len; _key++) {
    msg[_key] = arguments[_key];
  }

  (_console = console).log.apply(_console, ["useToken [".concat((0, _moment.default)().format("HH:mm:ss.SSS"), "]")].concat(msg));
};

function useToken(bugId) {
  var _useState = (0, _react.useState)(bugId),
      _useState2 = _slicedToArray(_useState, 2),
      debugId = _useState2[0],
      setDebugId = _useState2[1];

  var _useState3 = (0, _react.useState)(TOKEN_CACHE),
      _useState4 = _slicedToArray(_useState3, 2),
      token = _useState4[0],
      setToken = _useState4[1]; // handle token changes


  var onTokenChange = function onTokenChange(event) {
    var t = event.detail;

    if (t) {
      var same = false;

      if (token) {
        same = token.token === t.token;
      }

      if (!same) {
        log(debugId, "token changed", t);
        setToken(t);
      }
    } else {
      log(debugId, "token cleared");
      TOKEN_CACHE = null;
      setToken(null);
    }
  }; // listen for token changes


  (0, _react.useEffect)(function () {
    document.addEventListener("trc-token-changed", onTokenChange);
    return function () {
      document.removeEventListener("trc-token-changed", onTokenChange);
    };
  }, [token]); // manage token state

  (0, _react.useEffect)(function () {
    var ttl = -1;

    if (token && token.timestamp) {
      var age = Date.now() / 1000 - token.timestamp;
      ttl = 5 * 60 - age;
    }

    var ot = (0, _getProperty.getProperty)("token", token, null);
    var ct = (0, _getProperty.getProperty)("token", TOKEN_CACHE, null);

    if (ot !== ct) {
      log(debugId, "effect token changed", "ot", ot, "ct", ct);
      setToken(TOKEN_CACHE);
      return;
    }

    var tsl = Date.now() - LAST_TOKEN_REQUEST; // using 20 seconds to live gives us a little buffer time

    if (ttl <= MIN_TTL && !TOKEN_LOADING && tsl > 200) {
      LAST_TOKEN_REQUEST = Date.now();
      TOKEN_LOADING = true;
      log(debugId, "requesting token");
      (0, _getAuthToken.getAuthToken)().then(function (t) {
        TOKEN_LOADING = false;

        if (!t) {
          var anonToken = {
            user_id: 0,
            token: "",
            timestamp: Math.round(Date.now() / 1000)
          };
          TOKEN_CACHE = anonToken;
          log(debugId, "gotToken", anonToken);
          setToken(anonToken);
          document.dispatchEvent(new CustomEvent("trc-token-changed", {
            detail: anonToken
          }));
        } else {
          TOKEN_CACHE = t;
          log(debugId, "gotToken", t);
          setToken(t);
          document.dispatchEvent(new CustomEvent("trc-token-changed", {
            detail: t
          }));
        }
      });
    }
  });
  return token;
}